import React from "react";
import "./MainHeader.css";
import { useNavigate } from "react-router-dom";

import krrlogo from "../assets/logo.jpg";
import iworkkzlogo from "../assets/iWORKKZ.png";
import { FaUserShield } from "react-icons/fa";
import { FaClipboardList } from "react-icons/fa";
import { FaCommentDots } from "react-icons/fa";
import { FaQuestionCircle } from "react-icons/fa";

export default function MainHeader({ active, setActive }) {
  const navigate = useNavigate();

  // Get token
  const token = sessionStorage.getItem("sso_token");

  // Default role
  let userRole = "";

  // Decode JWT token
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));

      userRole = payload.role;
    } catch (error) {
      console.error("Invalid token");
    }
  }

  return (
    <div className="headercontainer">
      {/* <div className="header-logocontainer">
        <img src={krrlogo} alt="krrlogo" className="krrlogo" />
        <img src={iworkkzlogo} alt="iworkkzlogo" className="iworkkzlogo" />
      </div> */}

      <div className="header-menubar">
        <button
          className={active === "Feedback" ? "active-btn" : ""}
          onClick={() => setActive("Feedback")}
        >
          <FaCommentDots style={{ marginRight: "6px" }} />
          Feedback
        </button>

        <button
          className={active === "Enquiry" ? "active-btn" : ""}
          onClick={() => setActive("Enquiry")}
        >
          <FaQuestionCircle style={{ marginRight: "6px" }} />
          Enquiry
        </button>

        {/* Show only for Admin */}
        {userRole?.toLowerCase() === "admin" && (
          <button
            className={active === "Admin" ? "active-btn" : ""}
            onClick={() => setActive("Admin")}
          >
            <FaUserShield style={{ marginRight: "6px" }} />
            Admin
          </button>
        )}

        <button
          className={active === "Order" ? "active-btn" : ""}
          onClick={() => setActive("Order")}
        >
          <FaClipboardList style={{ marginRight: "6px" }} />
          Book Order
        </button>
      </div>
    </div>
  );
}
